import React, { useState } from "react";
import { IconButton } from "react-native-paper";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import AppButton from "../Common/ui/AppButton";
import AppDialog from "../Common/ui/AppDialog";
import { BRAND_COLORS, STATUS_COLORS } from "../../style/colors";

export const FinishMOButton = ({ finishMO }) => {
  const [confirmVisible, setConfirmVisible] = useState(false);

  const confirmFinish = () => {
    setConfirmVisible(true);
  };

  const handleConfirm = () => {
    setConfirmVisible(false);
    finishMO();
  };

  return (
    <>
      <div title='Finalizar MO'>
        <IconButton
          icon={() => (
            <MaterialCommunityIcons
              name='checkbox-marked-outline'
              size={32}
              color={STATUS_COLORS.ERROR}
            />
          )}
          onPress={confirmFinish}
          accessibilityLabel='Finalizar MO'
        />
      </div>
      <AppDialog
        open={confirmVisible}
        onClose={() => setConfirmVisible(false)}
        title='Finalizar MO'
        maxWidth='xs'
        actions={
          <>
            <AppButton
              onClick={() => setConfirmVisible(false)}
              variantType='secondary'>
              Cancelar
            </AppButton>
            <AppButton
              onClick={handleConfirm}
              variantType='danger'
              sx={{
                "&:hover": {
                  backgroundColor: BRAND_COLORS.PRIMARY,
                  borderColor: BRAND_COLORS.PRIMARY,
                },
              }}>
              Finalizar
            </AppButton>
          </>
        }>
        ¿Seguro que quieres finalizar esta MO?
      </AppDialog>
    </>
  );
};
